import React from 'react';

class ModuleErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[${this.props.moduleName || 'Module'}] Runtime error:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ textAlign: 'center', maxWidth: '480px', padding: '2rem' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠</div>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', marginBottom: '0.5rem' }}>
              {this.props.moduleName || 'Module'} failed to load
            </h2>
            <p style={{ fontSize: '0.875rem', color: '#6b7280', marginBottom: '1.5rem' }}>
              An error occurred in this module. Other modules are unaffected.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
              <button
                onClick={() => this.setState({ hasError: false, error: null })}
                style={{
                  padding: '0.5rem 1.25rem', fontSize: '0.85rem', fontWeight: 600,
                  background: '#111827', color: 'white', border: 'none',
                  borderRadius: '0.5rem', cursor: 'pointer'
                }}
              >
                Retry
              </button>
              <button
                onClick={() => window.location.href = '/portal'}
                style={{
                  padding: '0.5rem 1.25rem', fontSize: '0.85rem', fontWeight: 600,
                  background: 'white', color: '#374151', border: '1px solid #d1d5db',
                  borderRadius: '0.5rem', cursor: 'pointer'
                }}
              >
                Back to Portal
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ModuleErrorBoundary;
